import React, { useEffect, useState } from "react";
import { TextField, Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import { SimuladorIncentivoOR } from "./SimuladorIncentivoOR";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import CellTowerIcon from "@mui/icons-material/CellTower";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import StarsIcon from "@mui/icons-material/Stars";
import SimuladorNumericInput from "./SimuladorNumericInput";
import BuildIcon from '@mui/icons-material/Build';
import ConstructionIcon from '@mui/icons-material/Construction';
import BathroomIcon from '@mui/icons-material/Bathroom';
import { SimuladorIncentivosRRiego } from "./SimuladorIncentivosRRiego";
import { SimuladorIncentivosRRefacciones } from "./SimuladorIncentivosRRefacciones";
import { SimuladorIncentivoORBasico } from "./SimuladorIncentivoORBasico";
import ConnectingAirportsIcon from '@mui/icons-material/ConnectingAirports';


const SimuladorIncentivosRefaccionesScreen = ({ puesto }) => {
    const [formData, setFormData] = useState({
        nombre: "",
        puesto: "",
        fecha: "",
        monto: "",
        sucursal: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // REFACCIONES
    const [tipo, setTipo] = useState("")

    const handleTipoChange = (e) => {
        setTipo(e.target.value);
    };

    const rangoTipo1 = [
        { minimo: 0, maximo: 79.99, porcentaje: 0.0080 },
        { minimo: 80, maximo: 89.99, porcentaje: 0.0090 },
        { minimo: 90, maximo: 99.99, porcentaje: 0.0100 },
        { minimo: 100, maximo: 119.99, porcentaje: 0.0115 },
        { minimo: 120, maximo: 150000, porcentaje: 0.0120 },
    ]

    const rangoTipo2 = [
        { minimo: 0, maximo: 79.99, porcentaje: 0.0120 },
        { minimo: 80, maximo: 89.99, porcentaje: 0.0140 },
        { minimo: 90, maximo: 99.99, porcentaje: 0.0160 },
        { minimo: 100, maximo: 119.99, porcentaje: 0.0190 },
        { minimo: 120, maximo: 150000, porcentaje: 0.0210 }
    ]

    const rangoTipo3 = [
        { minimo: 0, maximo: 79.99, porcentaje: 0.0160 },
        { minimo: 80, maximo: 89.99, porcentaje: 0.0180 },
        { minimo: 90, maximo: 99.99, porcentaje: 0.0200 },
        { minimo: 100, maximo: 119.99, porcentaje: 0.0240 },
        { minimo: 120, maximo: 150000, porcentaje: 0.0260 }
    ]


    //FERRETERIA
    const [sucursal, setSucursal] = useState("")
    const [adr, setAdr] = useState("")

    const handleAdrChange = (e) => {
        setSucursal(e.target.value)

        if (Number(e.target.value) % 2 === 0)
            setAdr("2");
        else {
            setAdr("1");

        }

    };

    const rangoSinaloa = [
        { minimo: 0, maximo: 79.99, porcentaje: 0.0050 },
        { minimo: 80, maximo: 89.99, porcentaje: 0.0060 },
        { minimo: 90, maximo: 99.99, porcentaje: 0.0070 },
        { minimo: 100, maximo: 109.99, porcentaje: 0.01 },
        { minimo: 110, maximo: 119.99, porcentaje: 0.0110 },
        { minimo: 120, maximo: 150000, porcentaje: .0120 },
    ]

    const rangoNayarit = [
        { minimo: 0, maximo: 79.99, porcentaje: 0.0150 },
        { minimo: 80, maximo: 89.99, porcentaje: 0.0160 },
        { minimo: 90, maximo: 99.99, porcentaje: .0170 },
        { minimo: 100, maximo: 109.99, porcentaje: .02 },
        { minimo: 110, maximo: 119.99, porcentaje: .0230 },
        { minimo: 120, maximo: 150000, porcentaje: .0250 },
    ]

    //SISTEMA DE RIEGO

    // const [sucursal, setSucursal] = useState("")
    // const [adr, setAdr] = useState("")

    // const handleAdrChange = (e) => {
    //     setSucursal(e.target.value)

    //     if (Number(e.target.value) % 2 === 0)
    //         setAdr("2");
    //     else {
    //         setAdr("1");

    //     }

    // };

    const rangoSistemasRiego = [
        { minimo: 0, maximo: 79.99, porcentaje_proyectos: 0.0150, porcentaje_productos: 0.0110 },
        { minimo: 80, maximo: 89.99, porcentaje_proyectos: 0.0170, porcentaje_productos: 0.0130 },
        { minimo: 90, maximo: 99.99, porcentaje_proyectos: 0.0190, porcentaje_productos: 0.0150 },
        { minimo: 100, maximo: 109.99, porcentaje_proyectos: 0.0230, porcentaje_productos: 0.0190 },
        { minimo: 110, maximo: 119.99, porcentaje_proyectos: 0.0250, porcentaje_productos: 0.0210 },
        { minimo: 120, maximo: 150000, porcentaje_proyectos: 0.0270, porcentaje_productos: 0.0230 },
    ]

    const [porcIncentivo, setPorcIncentivo] = useState(0)

    //TOTALES
    const [totalRefacciones, setTotalRefacciones] = useState(0)
    const [totalFerreteria, setTotalFerreteria] = useState(0)
    const [totalRiego, setTotalRiego] = useState(0)
    const [totalDrones, setTotalDrones] = useState(0)
    const [totalVapormatic, setTotalVapormatic] = useState(0)

    const [totalIncentivo, setTotalIncentivo] = useState(0)


    useEffect(() => {
        let total = 0;

        total = totalRefacciones + totalFerreteria + totalRiego + totalDrones + totalVapormatic;

        setTotalIncentivo(total)

    }, [totalRefacciones, totalFerreteria, totalRiego, totalDrones, totalVapormatic]);
    return (
        <>
            <div className="simulador-incentivo-form-seccion">
                <FormControl fullWidth size="small" sx={{ mb: 2, background: '#dae6be' }}>
                    <InputLabel id="sucursal-label">Tipo</InputLabel>
                    <Select
                        labelId="sucursal-label"
                        value={tipo}
                        label="Sucursal"
                        onChange={(e) => handleTipoChange(e)}
                    >
                        <MenuItem value="1">Tipo 1: Navolato, El Dorado, Santiago I, Tecuala</MenuItem>
                        <MenuItem value="2">Tipo 2: Tepic, San Jose, Costa Rica, La Cruz, El Rosario</MenuItem>
                        <MenuItem value="3">Tipo 3: Caimanero, San Vicente, Villa Unión</MenuItem>
                    </Select>
                </FormControl>
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <BuildIcon /> Refacciones
                    </div>
                    <SimuladorIncentivosRRefacciones
                        rango={tipo === "1" ? rangoTipo1 : tipo === "2" ? rangoTipo2 : tipo === "3" ? rangoTipo3 : null}
                        setIncentivo={setPorcIncentivo}
                        setTotal={setTotalRefacciones}
                    />

                </div>
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <ConstructionIcon sx={{ fontSize: "18px" }} /> Ferreteria
                    </div>
                    <SimuladorIncentivoORBasico
                        porc_Incentivo={porcIncentivo ? porcIncentivo : 0}
                        setTotal={setTotalFerreteria}
                    />
                </div>
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <BathroomIcon sx={{ fontSize: "18px" }} /> Sistemas de Riego
                    </div>
                    <SimuladorIncentivoORBasico
                        porc_Incentivo={porcIncentivo ? porcIncentivo : 0}
                        setTotal={setTotalRiego}
                    />
                </div>
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <ConnectingAirportsIcon sx={{ fontSize: "18px" }} /> Drones
                    </div>
                    <SimuladorIncentivoORBasico
                        porc_Incentivo={porcIncentivo ? porcIncentivo : 0}
                        setTotal={setTotalDrones}
                    />
                </div>
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <BuildIcon sx={{ fontSize: "18px" }} /> Varios Vapormatic
                    </div>
                    <SimuladorIncentivoORBasico
                        porc_Incentivo={porcIncentivo ? porcIncentivo : 0}
                        setTotal={setTotalVapormatic}
                    />
                </div>
            </div >
            <div className="simulador-incentivo-nuevoformat">
                <div className="simulador-incentivo-form-titulos">
                    <span>
                        Considerando los datos ingresados, tu Incentivo total simulado es:
                    </span>
                    <SimuladorNumericInput
                        name="Total"
                        label=""
                        value={totalIncentivo}
                        disabled={true}
                        icono="none"
                        align="centro"
                    />
                </div>
                <div className="simulador-incentivo-form-titulo-leyenda">
                    Este simulador presenta escenarios de compensación estimados con base en los resultados ingresados. Su contenido no representa información oficial ni compromiso de pago
                </div>
            </div>
        </>
    );
};

export default SimuladorIncentivosRefaccionesScreen;
